import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Config } from 'src/app/core/Config';
import { environment } from '../../../../../../environments/environment';
import { CreateOem, AllOEM } from '../models/oem';

const BASE_URL = environment.BASE_URL;

@Injectable({
  providedIn: 'root'
})
export class OemService {

  constructor(
    public httpClient: HttpClient,
    public config: Config
  ) { }

  createOem(oemDetails: CreateOem) {
    return this.httpClient.post(BASE_URL + this.config.createOem, oemDetails).pipe(
      map((res) => {
        return res;
      })
    )
  }

  updateOem(oemDetails: CreateOem) {
    return this.httpClient.patch(BASE_URL + this.config.updateOem, oemDetails).pipe(
      map((res) => {
        return res;
      })
    )
  }

  getOemList(pageIndex: number, pageSize: number,): Observable<AllOEM> {
    let params = new HttpParams()
      .append("pageIndex", pageIndex)
      .append("pageSize", pageSize)
      .append("download", false);
    return this.httpClient.get<AllOEM>(BASE_URL + this.config.getOemLists, { params })
      .pipe(
        map((oem) => {
          return oem;
        })
      )
  }

}
